const FooterSection = ({ errorFileds }) => {
    return <div className="footer-section d-md-flex justify-content-between align-items-center">
    {Array.isArray(errorFileds) ? <div className="error-summary mb-3 mb-md-0">
        <p className="mb-0 text-danger">Error Summary</p>
        {errorFileds?.map((item, index) => <div className="mt-1 d-flex justify-content-start align-items-center" key={index}>
            <span className="error-count me-1">{(index + 1)}</span>
            <span>{item?.message || item?.error || item?.y_status || item}</span>
        </div>)}
    </div> : <div></div>}
</div>
}

export default FooterSection;